import styled, { css } from 'styled-components'
import MessageActions from './MessageActions'
import AvatarGenerator from 'components/AvatarGenerator/AvatarGenerator'
import { copyMessageText } from 'modals/AIChatModal/utils/copyMessageText'
import TypographyPrimary from 'components/Typography/Primary'
import AiMessageMarkdown from './AiMessageMarkdown'
import TypographySecondary from 'components/Typography/Secondary'
import LoadingDots from 'components/Loader/LoadingDots'

type HumanMessageProps = {
    avatarImg: string
    messageDate: string
    messageText: string
    userId?: string
    userName: string
    runId?: string
    onReplyClick?: () => void
    voice?: string
    loading?: boolean
    curlString?: string
}

const HumanMessage = ({
    avatarImg,
    messageDate,
    messageText,
    // userId,
    userName,
    // runId,
    onReplyClick,
    // voice,
    loading,
    curlString,
}: HumanMessageProps) => {
    return (
        <>
            <StyledMessageWrapper>
                <StyledAvatarWrapper>
                    <AvatarGenerator name={userName} size={50} avatar={avatarImg} />
                </StyledAvatarWrapper>

                <StyledMainContent>
                    <StyledMessageTop>
                        <StyledMessageInfo>
                            <TypographyPrimary value={userName} size={'xs-small'} />

                            <TypographySecondary value={messageDate} size={'xs-small'} />
                        </StyledMessageInfo>

                        <StyledMessageActionsWrapper className='actions'>
                            <MessageActions
                                onReplyClick={onReplyClick}
                                onCopyClick={() => copyMessageText(messageText)}
                                {...(curlString && {
                                    onCopyCurl: () => {
                                        copyMessageText(curlString)
                                    },
                                })}
                            />
                        </StyledMessageActionsWrapper>
                    </StyledMessageTop>
                    <StyledMessageText>
                        {loading ? (
                            <LoadingDots />
                        ) : (
                            <AiMessageMarkdown>{messageText}</AiMessageMarkdown>
                        )}
                    </StyledMessageText>
                </StyledMainContent>
            </StyledMessageWrapper>
        </>
    )
}

export default HumanMessage

export const StyledMessageWrapper = styled.div<{ secondary?: boolean }>`
    display: flex;

    align-items: flex-start;

    gap: 12px;
    padding-right: 10px;
    min-width: 400px;
    width: 100%;

    :hover {
        .actions {
            opacity: 1;
        }
    }

    ${props =>
        props.secondary &&
        css`
            flex-direction: row-reverse;
        `};
`

export const StyledMessageText = styled.div<{ secondary?: boolean }>`
    color: ${({ theme }) => theme.body.textColorPrimary};
    display: flex;
    padding: 0;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    gap: 8px;
    overflow-x: auto;

    width: 100%;
`

export const StyledMessageTop = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
`

export const StyledMainContent = styled.div<{ secondary?: boolean }>`
    display: flex;
    flex-direction: column;

    width: calc(100% - 60px);
    height: 100%;

    ${props =>
        props.secondary &&
        css`
            align-items: flex-end;
        `};
`
export const StyledAvatarWrapper = styled.div``

export const StyledMessageInfo = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;

    font-weight: 500;
`
export const StyledMessageActionsWrapper = styled.div`
    opacity: 0;
`
